module.exports = __webpack_public_path__ + "img/illus-fiche-cours-gratuite-2.c6177213.png";